import { render, staticRenderFns } from "./PreviewTable.vue?vue&type=template&id=222b9377&scoped=true&"
import script from "./PreviewTable.vue?vue&type=script&lang=js&"
export * from "./PreviewTable.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTable.vue?vue&type=style&index=0&id=222b9377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b9377",
  null
  
)

export default component.exports